import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    setUsers(state, users) {
        state.users = users;
    },

    addUser(state, user) {
        state.users.push(user);
    },
    updateUser(state, user) {
        if (empty(user.id)) {
            return;
        }

        // Find user
        const tmpUser = state.users.find(value => value.id == user.id);

        if (empty(tmpUser)) {
            return;
        }

        for (const i in user) {
            if (user.hasOwnProperty(i)) {
                tmpUser[i] = user[i];
            }
        }
    },
    deleteUser(state, user) {
        state.users.splice(state.users.findIndex(u => u.id == user.id), 1);
    },

    setEditingUser(state, user) {
        state.editingUser = user;
    },

    setSelectedUsers(state, users) {
        state.selectedUsers = users;
    },

    // PHONES

    setPhones(state, phones) {
        state.phones = phones;
    },
};
